module.exports = __webpack_public_path__ + "static/media/M mall shot 04.a783961c.webp";